import React, { createContext, useEffect, useState, useContext } from "react";
import arrayToTree from "../utils/arrayToTree";
import API from "../services/api";
import { AccountContext } from "context/account";

const defaultCategoryContext = {
  tree: [],
  tree_zh: [],
  actions: {
    findNodeByID: (tree, id) => {},
    findNodeByName: (tree, cat_name) => {},
    findParents: (tree, id, options) => {
      return [];
    },
    getAllLeaf: (node) => {},
    loadCategoryTree: (data, root_id) => {},
    refreshCategoryTree: (data, root_id) => {},
  },
};

const CategoryContext = createContext(defaultCategoryContext);
export default CategoryContext;

export const CategoryProvider = (props) => {
  const [tree, setTree] = useState(defaultCategoryContext.tree);
  const [tree_zh, setTreeZh] = useState(defaultCategoryContext.tree_zh);
  const account = useContext(AccountContext);

  let mytree = [];
  useEffect(() => {
    if (account.id) {
      refreshCategoryTree();
    }
  }, [account.id]);

  const refreshCategoryTree = async () => {
    if (tree.length > 0) {
      return;
    }

    try {
      const { data } = await API.stores.listTypes();

      const values = [];
      const values_zh = [];

      for (let i = 0; i < data.product_type.length; i++) {
        values.push({
          label: data.product_type[i]["value"],
          value: data.product_type[i]["id"],
          parent: data.product_type[i]["parent"],
        });
        values_zh.push({
          label: data.product_type[i]["value_zh"],
          value: data.product_type[i]["id"],
          parent: data.product_type[i]["parent"],
        });
      }
      const myTreeTemp = loadCategoryTree(values);
      const myTree_zhTemp = loadCategoryTree(values_zh);
      const myTree = formatNode(myTreeTemp);
      const myTree_zh = formatNode(myTree_zhTemp);
      setTree(myTree);
      setTreeZh(myTree_zh);
    } catch (err) {
      console.log(err);
    }
  };

  const findNodeByID = function (tree, id) {
    let node = {};
    const getChild = function (tree, id) {
      if (!tree) {
        return;
      }
      tree.forEach(function (row) {
        if (row.value == id || row.cat_id == id || row.id == id) {
          node = row;
        } else {
          getChild(row.children, id);
        }
      });
    };
    getChild(tree, id);
    return node;
  };

  const findNodeByName = function (tree, cat_name) {
    let node = {};
    const getChild = function (tree, cat_name) {
      if (!tree) {
        return;
      }
      tree.forEach(function (row) {
        if (row.label == cat_name || row.value == cat_name) {
          node = row;
        } else {
          getChild(row.children, cat_name);
        }
      });
    };
    getChild(tree, cat_name);
    return node;
  };

  const findParents = (
    tree,
    id,
    options = {
      findKey: "value",
      returnKey: "value",
    }
  ) => {
    const stack = [];
    let going = true;

    const walker = (tree, id) => {
      tree.forEach((item) => {
        if (!going) {
          return;
        }

        stack.push(item[options.returnKey]);

        if (item[options.findKey] === id) {
          going = false;
        } else if (item["children"]) {
          walker(item["children"], id);
        } else {
          stack.pop();
        }
      });
      if (going) {
        stack.pop();
      }
    };
    walker(tree, id);
    return stack;
  };

  const getAllLeaf = (node) => {
    const leaf = [];
    const data = [node];
    const getLeaf = function (data) {
      data.forEach(function (row) {
        if (row.children && row.children.length > 0) {
          getLeaf(row.children);
        } else {
          leaf.push(row.value);
        }
      });
    };
    getLeaf(data);
    return leaf;
  };

  const formatNode = (data) => {
    const getLeaf = function (data) {
      data.forEach(function (row) {
        if (row.children && row.children.length > 0) {
          row.selectable = true; //true: allow select parent node,false: can't select parent node
          row.id = row.value;
          row.value = row.label + "-" + row.value;

          getLeaf(row.children);
        } else {
          row.selectable = true;
          row.id = row.value;
          row.value = row.label + "-" + row.value;
        }
      });
    };
    getLeaf(data);
    return data;
  };

  // load category from json format
  const loadCategoryTree = function (data, rootId = "0") {
    mytree = arrayToTree(data, {
      id: "value",
      parentId: "parent",
      dataField: null,
      throwIfOrphans: false,
      rootParentId: rootId,
    });

    return mytree;
  };

  return (
    <CategoryContext.Provider
      {...props}
      value={{
        ...defaultCategoryContext,
        tree,
        tree_zh,
        actions: {
          findNodeByID,
          findNodeByName,
          findParents,
          getAllLeaf,
          loadCategoryTree,
          refreshCategoryTree,
        },
      }}
    />
  );
};
